module.exports = __webpack_public_path__ + "img/QR.cab82e1c.jpeg";